/**
 * Initial institution management UI rollout gate (Business Unit Management).
 *
 * **LaunchDarkly (primary):** boolean flag `jhft_initial_institution` (`FeatureFlags.INITIAL_INSTITUTION`).
 * Fail-closed default **false** — management actions stay hidden unless LD explicitly enables.
 *
 * **Optional build override:** `VITE_ENABLE_INITIAL_INSTITUTION` — set to `false` / `0` / `no` to force off;
 * `true` / `1` / `yes` to force on regardless of LD.
 */

import { FeatureFlags } from "./launchdarkly-config";
import { isFeatureEnabled } from "./launchdarkly-helpers";

function viteOverride(): boolean | undefined {
	const raw = String(import.meta.env.VITE_ENABLE_INITIAL_INSTITUTION ?? "").trim().toLowerCase();
	if (raw === "false" || raw === "0" || raw === "no") return false;
	if (raw === "true" || raw === "1" || raw === "yes") return true;
	return undefined;
}

/** When false, institution/BU management affordances must not render and add/edit routes must redirect. */
export function isInitialInstitutionFeatureEnabled(): boolean {
	const v = viteOverride();
	if (v === false) return false;
	if (v === true) return true;
	return isFeatureEnabled(FeatureFlags.INITIAL_INSTITUTION, false);
}
